import { validatePeriodSearch } from '../report-period'
import type { ReportPeriodSearch } from '../report-period'
import type { SalesReportParams } from '@/lib/api/report-api'

/** Kỳ mặc định của Báo cáo bán hàng: Hôm nay → mở thẳng chứng từ của hôm nay. */
export const SALES_DEFAULT_PRESET = 'today' as const

export const SALE_METHODS = ['counter', 'delivery'] as const
export type SaleMethod = (typeof SALE_METHODS)[number]
export const SALE_CHANNELS = ['direct', 'phone', 'online', 'kiotviet'] as const
export type SaleChannel = (typeof SALE_CHANNELS)[number]
/**
 * Lọc theo phương thức của từng khoản thu/hoàn trong kỳ (M-78); `unpaid` = đơn
 * tạo trong kỳ chưa thu đồng nào trong kỳ. Bộ giá trị owner chốt 28/09.
 */
export const SALE_PAYMENTS = [
    'cash',
    'bank_transfer',
    'cod_via_carrier',
    'unpaid',
] as const
export type SalePayment = (typeof SALE_PAYMENTS)[number]

/** Bộ lọc Báo cáo bán hàng: kỳ chung + phương thức + kênh (rỗng = tất cả). */
export interface SalesReportSearch extends ReportPeriodSearch {
    method?: SaleMethod[]
    channel?: SaleChannel[]
    payment?: SalePayment[]
}

/** Chuỗi "a,b" hoặc mảng trên URL → mảng giá trị hợp lệ, theo thứ tự chuẩn. */
export function pickList<TValue extends string>(
    raw: unknown,
    allowed: readonly TValue[],
): TValue[] | undefined {
    const parts = Array.isArray(raw)
        ? raw.map(String)
        : typeof raw === 'string'
          ? raw.split(',')
          : []
    const picked = allowed.filter((v) => parts.includes(v))
    return picked.length > 0 ? picked : undefined
}

export function validateSalesReportSearch(
    raw: Record<string, unknown>,
): SalesReportSearch {
    return {
        // Báo cáo bán hàng mặc định Hôm nay (owner 30/09), khác kỳ chung.
        ...validatePeriodSearch({
            ...raw,
            preset: raw.preset ?? SALES_DEFAULT_PRESET,
        }),
        method: pickList(raw.method, SALE_METHODS),
        channel: pickList(raw.channel, SALE_CHANNELS),
        payment: pickList(raw.payment, SALE_PAYMENTS),
    }
}

/** Tham số API cho một khoảng ngày theo bộ lọc hiện tại. */
export function salesApiParams(
    search: SalesReportSearch,
    from: string,
    to: string,
): SalesReportParams {
    return {
        date_from: from,
        date_to: to,
        method: search.method?.join(','),
        channel: search.channel?.join(','),
        payment: search.payment?.join(','),
    }
}
